import { DriveItemInfoMap } from '../containers/DriveItemList/reducer';
import {
	DownloadManagerState,
	DownloadMode,
	DownloadStatus,
} from '../containers/DownloadManager/reducer';
import DownloadManagerUtils from './downloadManager';

export const collectReachableDriveItemIds = (
	driveItems: DriveItemInfoMap,
	rootIds: number[],
): Set<number> => {
	const reachable = new Set<number>();

	const visit = (driveItemId: number) => {
		if (!driveItemId || reachable.has(driveItemId)) {
			return;
		}

		const driveItem = driveItems[driveItemId];

		if (!driveItem) {
			return;
		}

		reachable.add(driveItemId);

		if (driveItem.resources) {
			driveItem.resources.forEach((resource) => visit(resource.id));
		}
	};

	rootIds.forEach((rootId) => visit(rootId));

	return reachable;
};

export const detectStaleOfflineDownloadIds = (
	downloadManager: DownloadManagerState,
	driveItems: DriveItemInfoMap,
	applicationGallery: number,
	sharedDirId?: number,
): number[] => {
	const rootIds = [applicationGallery];

	if (sharedDirId) {
		rootIds.push(sharedDirId);
	}

	const reachableIds = collectReachableDriveItemIds(driveItems, rootIds);

	return DownloadManagerUtils.getRequestedItemIds(downloadManager).filter((driveItemId) => {
		if (reachableIds.has(driveItemId)) {
			return false;
		}

		const managerItem = downloadManager.items[driveItemId];

		if (!managerItem || managerItem.mode !== DownloadMode.Requested) {
			return false;
		}

		if (!DownloadManagerUtils.isItemPersistentlyDownloaded(downloadManager, driveItemId)) {
			return false;
		}

		if (DownloadManagerUtils.isItemDownloading(downloadManager, driveItemId)) {
			return false;
		}

		if (managerItem.status === DownloadStatus.ERROR
			|| managerItem.status === DownloadStatus.STARTING_DELETION) {
			return false;
		}

		return true;
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/staleOfflineDownloads.ts